import {
	fontFamily,
	fontWeightBold,
	fontWeightLight,
	fontWeightMedium,
	fontWeightRegular,
} from '@/constants'

const Typography = {
	htmlFontSize: 16,
	fontFamily,
	fontWeightLight,
	fontWeightRegular,
	fontWeightMedium,
	fontWeightBold,
	h1: {
		fontWeight: fontWeightLight,
		fontSize: '6rem',
		lineHeight: 1.16,
		letterSpacing: '-1.5px',
	},
	h2: {
		fontWeight: fontWeightLight,
		fontSize: '3.75rem',
		lineHeight: 1.2,
		letterSpacing: '-0.5px',
	},
	h3: {
		fontWeight: fontWeightRegular,
		fontSize: '3rem',
		lineHeight: 1.16,
		letterSpacing: 0,
	},
	h4: {
		fontWeight: fontWeightRegular,
		fontSize: '2.125rem',
		lineHeight: 1.23,
		letterSpacing: '0.25px',
	},
	h5: {
		fontWeight: fontWeightRegular,
		fontSize: '1.5rem',
		lineHeight: 1.33,
		letterSpacing: 0,
	},
	h6: {
		fontWeight: fontWeightMedium,
		fontSize: '1.25rem',
		lineHeight: 1.6,
		letterSpacing: '0.15px',
	},
	caption: {
		fontWeight: fontWeightRegular,
		fontSize: '0.75rem',
		lineHeight: 1.66,
		letterSpacing: '0.4px',
	},
	body1: {
		fontWeight: fontWeightRegular,
		fontSize: '1rem',
		lineHeight: 1.5,
		letterSpacing: '0.15px',
	},
	body2: {
		fontWeight: fontWeightRegular,
		fontSize: '0.875rem',
		lineHeight: 1.43,
		letterSpacing: '0.17px',
	},
	subtitle1: {
		fontWeight: fontWeightRegular,
		fontSize: '1rem',
		lineHeight: 1.75,
		letterSpacing: '0.15px',
	},
	subtitle2: {
		fontSize: '0.875rem',
		fontWeight: fontWeightMedium,
		lineHeight: 1.57,
		letterSpacing: '0.1px',
	},
	overline: {
		fontWeight: fontWeightRegular,
		fontSize: '0.75rem',
		lineHeight: 2.66,
		letterSpacing: '1px',
	},
	button: {
		fontWeight: fontWeightBold,
		fontSize: '0.875rem',
		lineHeight: 1.15,
		letterSpacing: 1.25,
	},
}

export default Typography
